enum SystemComponentCode {
  CALLCENTER = "callcenter",
  PAYGATE = "paygate",
  ISDS = "isds",
  ESHOP = "eshop",
  DISTRIBUTION = "distribution",
  CP = "cp",
  KIOSKS = "kiosks",
  EUROOIL = "eurooil",
  OTHER = "other",
}

export default SystemComponentCode;
